import {
  isAnswerSets,
  isObjectAnswer,
  type CorrectAnswerType,
} from "./problemAnswerUtils";
import type { ProblemAnswerDraftValue } from "./random-problems-persistence";

/** 초안과 정답 공개 세션은 현재 문제의 입력란 구성이 같을 때만 복원한다. */
export function isDraftCompatible(
  draft: ProblemAnswerDraftValue,
  correctAnswer: CorrectAnswerType
): boolean {
  const answerObject = isAnswerSets(correctAnswer)
    ? correctAnswer[0]
    : isObjectAnswer(correctAnswer)
      ? correctAnswer
      : null;

  if (!answerObject) return typeof draft === "string";
  if (!draft || typeof draft !== "object" || Array.isArray(draft)) return false;

  const answerKeys = Object.keys(answerObject);
  return (
    Object.keys(draft).length === answerKeys.length &&
    answerKeys.every((key) => Object.prototype.hasOwnProperty.call(draft, key))
  );
}
